export default {
    i: {
        select: {
            placeholder: '请选择',
            noMatch: '无匹配数据',
            loading: '加载中'
        },
        table: {
            noDataText: '暂无数据',
            noFilteredDataText: '暂无筛选结果',
            confirmFilter: '筛选',
            resetFilter: '重置',
            clearFilter: '全部'
        },
        datepicker: {
            selectDate: '选择日期',
            selectTime: '选择时间',
            startTime: '开始时间',
            endTime: '结束时间',
            clear: '清空',
            ok: '确定',
            month: '月',
            month1: '1 月',
            month2: '2 月',
            month3: '3 月',
            month4: '4 月',
            month5: '5 月',
            month6: '6 月',
            month7: '7 月',
            month8: '8 月',
            month9: '9 月',
            month10: '10 月',
            month11: '11 月',
            month12: '12 月',
            year: '年',
            weeks: {
                sun: '日',
                mon: '一',
                tue: '二',
                wed: '三',
                thu: '四',
                fri: '五',
                sat: '六'
            },
            months: {
                m1: '1月',
                m2: '2月',
                m3: '3月',
                m4: '4月',
                m5: '5月',
                m6: '6月',
                m7: '7月',
                m8: '8月',
                m9: '9月',
                m10: '10月',
                m11: '11月',
                m12: '12月'
            }
        },
        transfer: {
            titles: {
                source: '源列表',
                target: '目的列表'
            },
            filterPlaceholder: '请输入搜索内容',
            notFoundText: '列表为空'
        },
        modal: {
            okText: '确定',
            cancelText: '取消'
        },
        poptip: {
            okText: '确定',
            cancelText: '取消'
        },
        page: {
            prev: '上一页',
            next: '下一页',
            total: '共',
            item: '条',
            items: '条',
            prev5: '向前 5 页',
            next5: '向后 5 页',
            page: '条/页',
            goto: '跳至',
            p: '页'
        },
        rate: {
            star: '星',
            stars: '星'
        },
        tree: {
            emptyText: '暂无数据'
        }
    },
    logisticsMenu: {
        logisCurrentPosition: '当前位置',
        logisticsProvider: '物流商',
        personalCenter: '个人中心',
        channelManagement: '渠道管理',
        logisticsDealer: '包裹管理',
        customerAnalysis: '客户分析',
        customerManagement: '客户管理',
        waybillNumber: '运单号管理',
        pricingModelManagement: '计费模型',
        logisManagement: '基础信息管理',
        logisBizManagement:'业务信息管理',
        logisAccessManagement:'访问管理',
        FreightForwarding:'货代',
        OverseasWarehouse:'海外仓',
        warehouseManagement:'仓库管理',
        findpassword:'找回密码',
        dataReview:'物流审核',
        carrierParam:'物流信息',
        statisticsPackageInfo:'包裹统计(被动对接)',
        carrierAccount:'物流账号',
        accessStatistics:'访问管理',
        accessStatistics_admin:'接口频率统计(被动对接)',
        packageInfo:'包裹信息(被动对接)',
        logManagement:'日志管理(主动对接)'
    },
    logisticsProvider: {
        country: '国家',
        hasCountry: '已选中国家',
        wayname: '客户',
        trackNum: '已用跟踪号',
        noTrackNum: '未用跟踪号',
        channelName: '渠道名称',
        channelNum: '渠道代码',
        shippingCompanyId:'物流公司ID',
        useAll: '总使用数',
        addtext: '文本添加',
        excelImport: 'excel导入',
        textPlaceholder: '请输入跟踪号，多个用英文逗号隔开',
        trackExcelImport: '导入跟踪号',
        addTrack: '请选择导入文件',
        addFile: '选择文件',
        uploadFile: '上传文件',
        downLoadMoban: '下载模板',
        baseInformation: '基本信息',
        remark:'此界面提供修改的数据以必填为准,非必填的未必有使用到，可为后续扩展。非必填数据部分未填写的会自动填写默认值，请悉知。',
        channelInformation: '渠道信息',
        channelType: '类型',
        packageNum: '包裹数',
        cost: '费用',
        region: '地区',
        logisticsTrackNum: '物流跟踪号',
        packageNums: '包裹号',
        weight: '重量(g)',
        date: '日期',
        companyInfo: '公司信息',
        exceedSize: '文件大小超出限制，最大为10M',
        editData: '修改资料',
        overPackage1: '您已超过',
        overPackage2: '的物流商',
        addCanal: '新增',
        addChannels: '新增渠道',
        addWarehouse:'新增仓库',
        expectTime: '预计时效',
        chargingModel: '计费模型',
        shipment: '物流商',
        shipImport: '导入',
        addZone: '新增分区',
        area: '区',
        setChargModel: '设置计费模型',
        province: '省份',
        city: '城市',
        searchCity: '查询城市',
        noFile: '请选择文件',
        loadExcelTitle: '导入运费模板',
        loadExcelShippingMethod:'导入渠道模版',
        downloadExcel: '模板下载',
        selectExcel: '选择需要导入的模板',
        importSuccess: '导入数据成功',
        priceFormula: '计费公式',
        enterShipDes: '可以输入发货说明',
        editWaybillNum: '编辑运单号',
        addChannelInfo: '新增渠道信息',
        editChannelInfo: '编辑渠道信息',
        importCountryNoFind: '导入的部分通达国家没在系统中找到',
        confirmAdd: '确认添加',
        selectAll: '全选',
        clear: '清空',
        addWeightArea: '新增重量区间',
        supportSearch: '支持中文、英文、二字码搜索',
        selectedCity: '已选中城市',
        prompt: '提示',
        warehouseName:'仓库名称',
        warehouseCode:'仓库代码',
        warehouse:'仓库',
        merchant:'商户',
        merchantId:'商户号',
        template:'模板',
        templateName:'模板名称',
        customInformation:'定制模板信息'
    },
    admin:{
        ttPacketId:'包裹号',
        merchantId:'商户号',
        ttPacketStatus:'包裹状态',
        failureReason:'失败原因',
        trackingNumber:'跟踪号',
        shippingMethodCode:'渠道编码',
        warehouse:'仓库',
        platform:'销售平台',
        length:'长',
        width:'宽',
        height:'高',
        recipientName:'收件人姓名',
        recipientTelephone:'收件人电话',
        recipientMobile:'收件人手机',
        recipientEmail:'收件人邮箱',
        recipientCountry:'收件人国家',
        recipientState:'收件人省/州',
        recipientCity:'收件人城市',
        recipientDistrict:'收件人区/县',
        recipientCompany:'收件人公司',
        recipientPostalCode:'收件人邮编',
        buyerPassportCode:'收件人识别编号',
        recipientAddress1:'收件人地址1',
        recipientAddress2:'收件人地址2',
        senderName:'寄件人姓名',
        senderTelephone:'寄件人电话',
        senderMobile:'寄件人手机',
        senderEmail:'寄件人邮箱',
        senderCountry:'寄件人国家',
        senderState:'寄件人省/州',
        senderCity:'寄件人城市',
        senderDistrict:'寄件人区/县',
        senderCompany:'寄件人公司',
        senderPostalCode:'寄件人邮编',
        senderAddress1:'寄件人地址1',
        senderAddress2:'寄件人地址2',
        declareCnName:'申报中文品名',
        declareEnName:'申报英文品名',
        goodsSku:'申报产品SKU',
        declareNumber:'申报产品数量',
        declareValue:'货品申报价值',
        declareWeight:'货品申报重量',
        hsCode:'海关编码',
        declareUrl:'申报的产品链接',
        material:'产品材质',
        purpose:'产品用途',
        productName:'货品名称',
        sku:'SKU',
        quantity:'货品数量',
        productWeight:'单品重量',
        cargoSpace:'货位号',
        iossMethod:'预缴增值税方式',
        iossNo:'卖家IOSS税号',
        eoriNo:'卖家EORI税号',
        voecNo:'卖家VOEC税号',
        gstNo:'卖家GST税号',
        vatNo:'卖家VAT税号',
        salesRecordNumber:'销售订单号',
        carrierOrderId:'物流单号',
        virtualTrackingNumber:'虚拟跟踪号',
        uploadCarrier:'承运商',
        weight:'重量',
        freight:'运费',
        templateType:'面单类型',
        templateContent:'面单地址',
        createdDate:'包裹生成时间',
        lastsyncTime:'最新同步时间',
        requestId:'请求ID',
        source:'来源',
        apiInterface:'物流商标识',
        method:'请求方式',
        interfaceFlag:'接口标识',
        carrierId:'物流商ID',
        rangeTime:'时间范围',
        packageStatus:'包裹状态',
        packageNum:'包裹数量'
    },
    sellerMenu: {
        sellerCurrentPosition: '当前位置',
        seller: '卖家',
        personalCenter: '个人中心',
        logisticsPlan: '物流方案查询',
        logisticsTracking: '物流追踪',
        logisticsReconciliation: '物流对账',
        logisBillManage: '物流账单管理',
        logisticsProvider: '我的物流商分析',
        logisticsChannel: '我的物流渠道分析',
        logisticsDetails: '物流详情',
        overseasWarehouse: '海外仓',
        overseasWarehouseDtl: '海外仓详情',
        overseasWarehouseInvent: '海外仓库存',
        overseasWarehouseBill: '海外仓账单'
    },
    sellers: {
        overSeller1: '您已超过',
        overSeller2: '的卖家',
        countrys: '目的国家',
        packageWeights: '包裹重量',
        packageVolumes: '包裹体积',
        packageType: '包裹类型',
        productsType: '货物类型',
        isEnabled: '是否启用',
        receiveCity: '揽收城市',
        selectCity: '选择揽收城市',
        userContactInfoTitle: '您的联系方式',
        shippingMethodName: '渠道名称',
        carrierName: '物流商名称',
        tongtoolExpoent: '通途推荐指数',
        averageTime: '平均时效',
        avgNetTime: '平均上网时间',
        availableTrackingRate: '有效追踪率(%)',
        lostPackageRate: '丢包率',
        pickupRate: '妥投率',
        selectCarrier: '选择物流商',
        packageNums: '包裹号',
        trackingNumber: '物流单号',
        erpPackageWeight: '通途重量',
        packageWeight: '物流商重量',
        weightAddRatio: '重量增加比(%)',
        erpPackageCost: '通途费用',
        packageCost: '物流商费用',
        costs: '费用',
        costAddRatio: '费用增加比(%)',
        selectExcel: '选择需要导入的模板',
        confirmImport: '确认导入',
        importLogisWeights: '导入物流商重量和费用',
        packageQuantity: '包裹数',
        useRatio: '使用占比(%)',
        costRatio: '费用占比(%)',
        shippingMethodCode: '渠道代码',
        isValid: '状态',
        shipDetails: '详情',
        avgDelieveredTime: '平均妥投时间',
        shortDelieveredTime: '最短妥投时间',
        longDelieveredTime: '最长妥投时间',
        platform: '平台',
        storeName: '店铺',
        country: '国家',
        shippingMethods: '物流方式',
        recentData: '统计最近90天数据',
        logisTrackInfo: '物流跟踪信息',
        targetLanguage: '请选择要转换的目标语言',
        copyResult: '复制结果',
        copyLink: '复制链接',
        languageConver: '语言转换',
        packetStatus: '包裹状态',
        transportMethods: '运输方式',
        transportTime: '运输时间',
        basicInfo: '基本信息',
        timeAndFreight: '时效及运费',
        templateManagement: '面单管理',
        tongToolTemplate: '通途模板',
        logisTemplate: '物流商模板',
        personalTemplate: '个人模板',
        arrivalTime: '预计妥投时间',
        unableShow: '该字段暂时无法显示',
        contactLogisProvider: '联系物流商',
        channelDtlTitle: '渠道详情',
        estimateFreight: '预估运费',
        querying: '查询中',
        delivering: '运输途中',
        pickingUp: '到达待取',
        signingSuccess: '成功签收',
        unableCheck: '查询不到',
        deliveryFail: '投递失败',
        transportLong: '运输过久',
        maybeAbnormal: '可能异常',
        logisFreightModel: '物流商计费模型',
        customShipModel: '自定义计费模型',
        billGenerateTime: '账单生成时间',
        importBill: '导入账单',
        billTimes: '账单时间',
        selectBillTime: '请选择账单生成时间',
        downloadDetails: '详情下载',
        downloads: '下载',
        paymentStatus: '付款状态',
        markAsPaid: '标记为已付款',
        selectLogisProvider: '请选择物流商',
        selectBillingTime: '请选择账单时间',
        paid: '已付款',
        unPaid: '未付款',
        importFormFile: '导入表格文件'
    },
    common: { // 重复类名词 + 公共操作提示
        merchantId: '商户编号',
        partnerId: '用户编号',
        companyName: '公司名称',
        displayCarrierName:'在通途显示的物流商名称',
        companyAds: '公司地址',
        email: '企业邮箱',
        mobile: '手机号码',
        contactName: '联系人',
        businessLicense:'营业执照',
        selectFile:'选择文件',
        supportPdf:'支持上传PDF文件',
        telephone: '联系电话',
        packNum: '包裹数量（近30天包裹数量）',
        yesterdayPm: '昨天包裹量',
        packageAmount: '包裹量',
        dates: '日期',
        nocompanyImg: '暂无图片',
        dataSources: '数据来源：通途物流平台',
        productServer: '产品服务',
        productName: '产品名称',
        productDes: '产品介绍',
        orderPrice: '订购价格',
        productStatus: '状态',
        searchName: '搜索字符',
        markSuccess: '标记成功',
        markFailed: '标记失败',
        editSuccess: '修改成功',
        saveSuccess: '保存成功',
        editFailed: '修改失败',
        saveFailed: '保存失败',
        delSuccess: '删除成功',
        delFailed: '删除失败,请重新尝试',
        clearMakrSuccess: '清空标签成功',
        operateSuccess: '操作成功',
        operateFailMes: '操作失败，请重新尝试',
        sysErrorMes: '系统繁忙，请重新尝试',
        lastWeek: '最近一周',
        lastMonth: '最近一个月',
        last3months: '最近三个月',
        selectDate: '选择日期',
        deliveryDate: '发货日期',
        search: '查询',
        statisticsAllPackageInfo:'统计所有包裹信息',
        reset: '重置',
        status: '状态',
        checkStatus: '审核状态',
        checkStatusFinish: '审核完成',
        operation: '操作',
        sort: '排序',
        close: '关闭',
        save: '保存',
        saveAndApproval:'保存并提交审核',
        submit: '提交',
        cancel: '取消',
        edit: '编辑',
        cancelEdit: '取消编辑',
        all: '全部',
        examine: '查看',
        del: '删除',
        logout: '登出',
        inputPrefix: '请输入',
        selectPrefix: '请选择',
        enableOk: '启用成功',
        disableOk: '停用成功',
        delOk: '删除成功',
        addOk: '新增成功',
        updateOk: '更新成功',
        deleteConfirm: '是否确认删除?',
        confirm: '确定',
        notNull: '不能为空',
        processing: '处理中...',
        emptyResult: '没有相关记录',
        warningMesTitle: '警告提示',
        selectFile: '选择文件',
        startUpload: '开始上传',
        shipImport: '导入',
        shipExport: '导出',
        exportSuccess: '导出成功',
        tableNoData: '当前没有可导出的数据',
        selectCountry: '选择国家',
        selectShipMethods: '选择物流方式',
        priceType: '计费方式',
        priceType0: '普通计费',
        priceType1: '首续重计费',
        priceType2: '分段计费',
        weightType: '计重方式',
        weightType0: '实重',
        weightType1: '抛重',
        weightType2: '两者比较',
        subCostWay0: '单位重量',
        subCostWay1: '固定收费',
        subCostWay2: '首续重收费',
        tableDes0: '运费 = (重量 * 单价 + 挂号费 + 操作费) * (1 + 附加费)',
        tableDes1: '运费 = {首重费用 + (包裹重量 - 首重) / 续重单位重量 * 续重单价 + 挂号费 + 操作费} * (1 + 附加费)',
        tableDes2: '运费 = (单价 + 挂号费 + 操作费) * (1 + 附加费)',
        logisType1: '平邮',
        logisType2: '挂号',
        logisType3: '专线',
        logisType4: '商业快递',
        logisType5: 'FBA头程',
        serialNum: '序号',
        status0: '停用',
        status1: '启用',
        companyAttr:'公司属性',
        thirdLogis:'第三方物流',
        overseasWarehouse:'海外仓',
        checkBtn:'审核',
        refuseBtn:'拒绝',
        rejected:'已拒绝',
        dataReviewStatus:'审核状态',
        dataReviewStatus0:'待申请',
        dataReviewStatus1:'待审核',
        dataReviewStatus2:'审核成功',
        dataReviewStatus3:'审核失败',
        searchText:'公司名称/手机号码/邮箱/物流商名称',
        checkstatus0: '待审核',
        checkstatus1: '已审核',
        checkstatus2: '已拒绝',
        checkstatus:'审核通过',
        checkstatusRj:'审核拒绝',
        cargo: '普货',
        battery: '纯电池',
        supBattery: '配套电池',
        liquid: '液体',
        medicine: '药品',
        powder: '粉末',
        dangerous: '危险品',
        package: '包裹',
        file: '文件',
        yes: '是',
        not: '否',
        referTime: '参考时效',
        safeServe: '保险服务',
        sizeLimit: '尺寸限制',
        useWeight: '适用重量',
        packageType: '可接受包裹类型',
        acceptType: '接收类型',
        haveTrackNum: '是否有跟踪号',
        channelTypes: '渠道类型',
        isPrintTemplate: '是否支持API接口传送面单',
        updateToErp:'是否推送到ERP2.0',
        confirmRequired: '是否需要交运',
        volumeWeight: '材积重',
        trackUrl: '追踪信息查询网址',
        collectCity: '揽收城市',
        dyParams: '动态参数',
        dyParamsExtend: '动态参数扩展信息',
        sendExplain: '发货说明',
        searchLogisName: '搜索物流商名称',
        searchChannelName: '搜索渠道名称',
        searchChannelCode: '搜索渠道代码',
        warehosueName:'搜索仓库名称',
        submitSuccess: '提交成功，等待物流商联系您',
        pleaseEnter: '请检查你填写的值是否符合要求',
        importFileSuccess: '导入文件成功',
        importFileFail: '导入文件失败',
        fileFormats: '文件格式',
        subArea: '分区',
        reachState: '通达国家',
        costPrice: '价格（元/g）',
        fixPrice: '价格（元/票）',
        registrationFee: '挂号费（元/票）',
        operatingCost: '操作费（元/票）',
        additionalFeeRate: '附加费（%）',
        firstWeight: '首重（g）',
        firstWeightPrice: '首重运费（元）',
        unitWeight: '续重单位重量（g）',
        unitWeightPrice: '续重单价（元）',
        monetaryUnit: '元',
        unitWeightTwo: '续重',
        firstWeightTwo: '首重',
        length: '长',
        width: '宽',
        height: '高',
        pleaseSelect: '请选择',
        fileSizeLimit: '超过文件大小限制',
        moreSize: '太大，不能超过2M',
        findSameCountry: '模板导入发现相同国家时',
        cover: '覆盖',
        ignore: '忽略',
        errorMessage: '错误提示',
        downloadErrorLog: '下载错误日志',
        startWeights: '起始重量（g）',
        endWeights: '截止重量<=（g）',
        batchImport: '批量导入',
        newPartition: '新增分区',
        backToList: '返回列表',
        checkErrorLog: '计费模型导入内容有误，请查看错误日志',
        isCheckStatus:'是否需要审核',
        label:'自制模板',
        userNo:'用户编号',
        carrierCode:'物流商代码',
        apiType:'API类型编码',
        carrierType:'物流商类型',
        remark:'备注',
        appmanage:'应用管理',
        addparam:'新增参数',
        parameterName:'参数名',
        parameterKey:'参数key',
        parameterType:'参数类型',
        businessType:'参数业务类型',
        dataType:'数据类型',
        optionName:'可选项名',
        optionValue:'可选项值',
        addAccount:'添加账号',
        updateAccount:'更新账号',
        updatePassword:'更新密码',
        hasAccount:'是否有账号',
        alreadyAccount:'已有账号',
        noAccount:'未有账号',
        accountName:'账号名称',
        password:'密码',
        account:'账号',
        carrierSystem:'物流系统',
        sync:'同步',
        initExtend:'初始化渠道扩展信息',
        bindType:'绑定类型',
        isSupportSmartRouting:'是否支持智能路由',
        isSupportPrivateChannelSync:'是否支持客户私有渠道同步',
        isSupportSecondaryForecast:'是否支持二次预报业务',
        secondaryForecastType:'二次预报类型',
        isEnableSynStock:'是否支持API同步库存',
        isSupportApiRecord:'是否支持API补录运费',
        accessTime:'访问时间',
        packageCreatedTime:'包裹创建时间',
        accessTimeRange:'访问时间范围',
        totalTimes:'访问频率',
        callMethod:'接口名称',
    },
    validValue: { // 所有的校验callback内容都写在这里，避免重复
        noEmpty: '内容不能为空',
        errorDate: '日期格式有误',
        fileError: '文件格式有误',
        inputError: '输入格式有误',
        floatNeed: '该选项只允许输入整数或两位小数',
        noshipMethodName: '渠道名称不能为空',
        noMerchantId: '商户不能为空',
        noTemplateId: '模板不能为空',
        nowarehosueName:'仓库名称不能为空',
        noshipMethodCode: '渠道代码不能为空',
        nowarehouseCode:'仓库代码不能为空',
        noReceiveType: '请选择接收类型',
        noLogisType: '请选择渠道类型',
        noEfficiencyMin: '最小参考时效不能为空',
        noEfficiencyMax: '最大参考时效不能为空',
        noLength: '长度不能为空',
        noWidth: '宽度不能为空',
        noHeight: '高度不能为空',
        noWeightStart: '重量起始值不能为空',
        noWeightEnd: '重量截止值不能为空',
        chMethodCode: '渠道代码不能为中文',
        isInteger: '只能大于0的整数',
        noLessZero: '不能小于0',
        minTimeNoLessZero: '最小参考时效不能小于0',
        noLessOrEqualZero: '不能小于等于0',
        maxTimeNoLessOrEqualZero: '最大参考时效不能小于等于0',
        lengthNoLessOrEqualZero: '长度不能小于等于0',
        widthNoLessOrEqualZero: '宽度不能小于等于0',
        heightNoLessOrEqualZero: '高度不能小于等于0',
        startWeightNoLessZero: '适用重量起始值不能小于0',
        endWeightNoLessOrEqualZero: '适用重量截止值不能小于等于0',
        trackUrlError: '查询网址格式不正确',
        noCountrys: '请选择国家',
        noCitys: '请选择揽收城市',
        noPackageWeight: '包裹重量不能为空',
        noCompanyName: '公司名称不能为空',
        noCompanyAddress: '公司地址不能为空',
        noEmail: '邮箱不能为空',
        emailError: '邮箱格式不正确',
        noLinkMan: '联系人不能为空',
        noCellphone: '手机号码不能为空',
        phoneError: '手机号码格式不正确',
        noStartMoreEnd: '适用重量起始值不能大于等于适用重量截止值',
        noStartTimeMoreEndTime: '参考时效起始值不能大于等于参考时效截止值',
        trackingNumberError: '输入的跟踪号码不是数字或者字母',
        noEnterTrackingNumber: '当前没有输入跟踪号码',
        trackingNotRepeat: '跟踪号码不能重复',
        noHasTrackingNumber:'是否有跟踪号必填',
        nobusinessLicense:'必须上传营业执照',
        nocarrierCode:'物流商代码必填',
        noremark:'备注必填',
        noAccount:'账号不能为空',
        noPassword:'密码不能为空',
        noBindType:'绑定类型不能为空'
    },
    error: {
        importError: '导入失败，请填写必填项',
        repeatImportCountry: '重复导入通达国家',
        importSameCountry: '不能重复添加相同的国家，请重新选择导入',
        addWeightInterval: '请添加重量区间',
        startWeightNoEmpty: '起始重量不能为空',
        endWeightNoEmpty: '截止重量不能为空',
        endWeightNoZero: '截止重量不能为0',
        endNoLessOrEqualStart: '截止重量不能小于等于起始重量',
        startWeightOnlyInteger: '起始重量只能是正整数',
        endWeightOnlyInteger: '截止重量只能是正整数',
        pricesOnlyFiveDecimals: '价格最多只能保留五位小数',
        firstWeightPriceOnlyFiveDecimals: '首重运费最多只能保留五位小数',
        unitWeightPriceOnlyFiveDecimals: '续重单价最多只能保留五位小数',
        registrationFeeOnlyFiveDecimals: '挂号费最多只能保留五位小数',
        operatingFeeOnlyFiveDecimals: '操作费最多只能保留五位小数',
        additionalFeeOnlyFiveDecimals: '附加费最多只能保留五位小数',
        endMoreStartWeight: '上一个分区的截止重量不能大于等于下一个分区的起始重量',
        countryAlreadyExist: '当前国家在当前计费模型中已经存在了，不能重复选择',
        importTableError: '导入失败，请检查导入的表格内容是否符合要求',
        shippingError: '渠道名称或渠道代码已存在',
        saveError: '保存失败，请检查你填写的值是否符合要求',
        fileFormatError: '文件格式不正确',
        noImportFiles: '请选择你要导入的文件',
        delPricingColumnsError: '至少保留一个重量区间',
        nonCountry: '请选择通达国家，且不可重复',
        selectModalFile: '请选择需要导入的模板',
        disableInsert: '有未填写的分区',
        decimalError: '不能为空，且最多只能保留五位小数',
        priceError: '价格不能为空，且不能为零',
        firstWeightError: '首重不能为空，且不能为零',
        firstWeightPriceError: '首重运费不能为空，且不能为零',
        unitWeightError: '续重不能为空，且不能为零',
        unitWeightPriceError: '续重价格不能为空，且不能为零',
        weightRegionError: '重量区间不能为空的正整数',
        delCachePricingData: '至少保留一条数据',
        templateDataError: '上传失败，excel中模板数据不能为空',
        templateDataError14: '普通计费模板表格参数不匹配或不完整',
        templateDataError15: '通达国家不能为空',
        templateDataError16: '运费不能为空',
        templateDataError17: '运费格式错误',
        templateDataError18: '挂号费格式错误',
        templateDataError19: '操作费格式错误',
        templateDataError20: '附加费格式错误',
        templateDataError21: '首续重计费表格参数不匹配或不完整',
        templateDataError22: '首重不能为空',
        templateDataError23: '首重格式错误',
        templateDataError24: '首重运费不能为空',
        templateDataError25: '首重运费格式错误',
        templateDataError26: '续重单位重量不能为空',
        templateDataError27: '续重单位重量格式错误',
        templateDataError28: '续重单价不能为空',
        templateDataError29: '续重单价格式错误',
        templateDataError30: '运费价格必须大于0',
        templateDataError31: '通达国家没在系统找到',
        templateDataError32: '首重重量必须大于0',
        templateDataError33: '首重运费必须大于0',
        templateDataError34: '续重重量必须大于0',
        templateDataError35: '续重运费必须大于0',
        templateDataError36: '区间续重重量或运费必须大于0',
        templateDataError37: '区间续重重量或运费格式错误',
        templateDataError38: '分段计费表格参数不匹配或不完整',
        templateDataError41: '物流对账文件内容不匹配',
        templateDataError42: '物流商重量格式错误',
        templateDataError43: '物流商费用格式错误',
        currentNoData: '当前没有操作表格数据',
        importWayBillNumExists: '导入的运单号已存在',
        shipDateNoEmpty: '发货日期不能为空',
        curTableNotData: '当前表格数据为空，不能导入Excel数据',
        errorTip10029: '国家信息不能为空',
        errorTip20044: '包裹重量不能为空',
        errorTip20045: '包裹体积不能为空',
        errorTip10006: '删除失败',
        errorTip90002: '系统繁忙，请稍候再试',
        errorTip90003: '系统内部异常，请联系管理员',
        errorTip90004: '数据库异常',
        errorTip10010: '参数错误',
        errorTip10011: '参数为空',
        errorTip10012: '参数对象为空',
        errorTip10014: 'CLIENT ID不合法',
        errorTip10015: 'SECRET不合法',
        errorTip10016: '对象已存在',
        errorTip10017: 'RESTFUL调用失败',
        errorTip10018: '对象为空',
        errorTip10019: '访问ES异常',
        errorTip10020: '查询跟踪信息异常',
        errorTip10021: '物流商不存在',
        errorTip10022: 'Excel文件格式错误',
        errorTip10023: '没有找到物流商',
        errorTip10024: '没有找到系统国家信息',
        errorTip10025: 'Excel文件导出异常',
        errorTip10026: '未找到结果信息',
        errorTip10027: '商户ID不能为空',
        errorTip10028: '渠道ID不能为空',
        errorTip20050: '跟踪号参数文件为空',
        errorTip20051: '修改渠道状态参数为空',
        errorTip20052: '修改渠道id参数为空',
        errorTip20053: '计费方式参数为空',
        errorTip20054: '计费模型文件参数为空',
        errorTip20055: 'EXCEL文件格式错误，请在附加费列填值，没有就填写0',
        errorTip20056: '文件参数为空',
        errorTip20057: '保存统计报表参数列表为空',
        errorTip20073: '是否有跟踪号值为空',
        errorTip20074: '仓库代码不能为空',
        errorTip20075: '仓库名称不能为空',
        errorTip20076: '仓库名称或代码已存在',
        errorTip20077: '仓库ID不能为空',
        errorTip20078: '仓库状态不能为空',
        errorTip20079: '接口代码不能为空',
        selectWarehouse:'请先选择仓库'
    }
};


// WEBPACK FOOTER //
// ./src/components/locale/lang/zh-CN.js